var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcForkKnifeTitlePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.7596H1.5V21.2596H22.5V19.7596Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.01961H19.5V4.01961H18V7.01961H15V8.51961H18V11.5196H19.5V8.51961H22.5V7.01961Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.19 2.64961C11.01 2.61961 10.81 2.59961 10.62 2.59961H10.05V16.3896H11.2V11.5396H12.63C13.19 11.5396 13.65 11.0796 13.65 10.5196V5.82961C13.65 4.05961 12.72 2.87961 11.2 2.64961H11.19ZM12.49 10.3896H11.19V3.82961C12.03 4.02961 12.49 4.71961 12.49 5.82961V10.3896Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 2.59961H4.11V8.30961H5.26V2.59961Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56 8.90961H2.79V2.59961H1.64V9.02961C1.64 9.59961 2.1 10.0596 2.67 10.0596H4.11V16.3796H5.26V10.0596H6.66C7.23 10.0596 7.69 9.59961 7.69 9.02961V2.59961H6.54V8.90961H6.56Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForkKnifeTitlePlus);
export default __webpack_public_path__ + "static/media/ic-fork-knife-title-plus.92c2a128c92be0f02ccdaa79cf946972.svg";
export { ForwardRef as ReactComponent };